import {useNavigate} from 'react-router-dom'
import {Center, Image, Text} from '@chakra-ui/react'
import {PATH} from '@utils/Const'
import GlobalButton from '@components/GlobalButton/GlobalButton'
import Logo from '@assets/svgs/logo.svg'

export const InternalServerErrorResult = () => {
  const navigate = useNavigate()
  return (
    <Center
      flex={1}
      flexDirection={'column'}
      h={'100vh'}
      gap={'16px'}
      px={'16px'}>
      <Image src={Logo} w={'300px'} />
      <Text fontWeight={'700'} fontSize={'24px'}>
        Đã có lỗi xảy ra
      </Text>
      <Text color={'red'} textAlign={'center'}>
        Vui lòng sử dụng tính năng khác hoặc báo cho chúng tôi biết về điều này!
      </Text>
      <GlobalButton mt={2} onClick={() => navigate(PATH.HOME, {replace: true})}>
        Trang chủ
      </GlobalButton>
    </Center>
  )
}
